import React from "react";
import "./MenuMobile.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressBook,
  faBars,
  faCameraRetro,
  faClose,
  faHeadphones,
  faHomeUser,
  faLeftLong,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../routes/url";
import logoImage from "../../../assets/images/happy_learning.jpg";

function MenuMobile() {
  const navigate: any = useNavigate();

  const goBack = () => {
    navigate(-1); // Điều này sẽ quay lại trang trước đó
  };
  return (
    <div className="wrapper-menu">
      <header className="header">
        <img
          src={logoImage}
          alt="logo"
          className="logo"
          style={{ width: "40px", height: "31px" }}
        />
        <input type="checkbox" id="check" />
        <label htmlFor="check" className="icons">
          <FontAwesomeIcon icon={faBars} size="1x" id="menu-icon" />
          <FontAwesomeIcon icon={faClose} size="1x" id="close-icon" />
        </label>

        <nav className="navbar">
          <a className="go-back" href="##" onClick={goBack}>
            <FontAwesomeIcon icon={faLeftLong} size="1x" color="#1677ff" /> Quay
            lại
          </a>
          <Link
            to={URL.CLIENT.HOME}
            style={{ "--i": 0 } as React.CSSProperties}>
            <FontAwesomeIcon icon={faHomeUser} size="1x" color="#1677ff" />{" "}
            Trang chủ
          </Link>
          <Link
            to={URL.CLIENT.POST}
            style={{ "--i": 1 } as React.CSSProperties}>
            <FontAwesomeIcon icon={faPenToSquare} size="1x" color="#1677ff" />{" "}
            Tập bút
          </Link>
          <Link
            to={URL.CLIENT.PODCAST}
            style={{ "--i": 2 } as React.CSSProperties}>
            <FontAwesomeIcon icon={faHeadphones} size="1x" color="#1677ff" />{" "}
            Podcast
          </Link>
          <Link to={""} style={{ "--i": 3 } as React.CSSProperties}>
            <FontAwesomeIcon icon={faCameraRetro} size="1x" color="#1677ff" />{" "}
            Photos
          </Link>
          <Link to={""} style={{ "--i": 4 } as React.CSSProperties}>
            <FontAwesomeIcon icon={faAddressBook} size="1x" color="#1677ff" />{" "}
            Contact
          </Link>
        </nav>
      </header>
    </div>
  );
}

export default MenuMobile;
